<form [formGroup]="form" (submit)="onSubmit($event)">
  @for (field of fields; track field) {
    <ng-container lhDynamicFormField [config]="field" [group]="form"></ng-container>
  }
</form>
